import styled from 'styled-components';
import { largeLayout } from '@styles/layout';
import { black, blue } from '@styles/colors';

export const Baseline = styled.h3`
  font-family: 'Avenir';
  font-size: 1.5rem;
  line-height: 2.125rem;
  font-weight: 500;
  font-weight: normal;
  color: ${black};
  width: ${largeLayout.getSize(6)}px;
  position: relative;
  padding-left: 15px;

  & > div {
    display: inline-block;
  }

  &:before {
    content: '';
    width: 4px;
    display: block;
    position: absolute;
    top: 5px;
    left: 0px;
    background: ${blue};
    bottom: 5px;
  }
  b {
    font-weight: 900;
  }
`;



// WEBPACK FOOTER //
// src/app/src/components/AnimatedBaseline/AnimatedBaseline.s.ts